import { Component, Input, OnInit } from '@angular/core';
import { Params, Router } from '@angular/router';
import { EFileStatusPill } from '../../models/efile-status-pill.model';

@Component({
  selector: 'spv2-home-page-card',
  templateUrl: './home-page-card.component.html',
  styleUrls: ['./home-page-card.component.scss']
})
export class HomePageCardComponent {

  @Input() title: { text: string, icon: string, useLargeTitle: boolean };
  @Input() extraQueryParams: Params;
  @Input() isForSubmissionOverview: boolean;
  @Input() eFileStatusPills: EFileStatusPill[];
  @Input() isLoadingStatusPills: boolean;

  constructor(public readonly router: Router) { }

  navigate(): void {
    let url = this.isForSubmissionOverview ? '/submissions/overview' : '/submissions/efile-overview';
    this.router.navigate([url], { queryParams: this.createQueryParams() })
  }

  isStatusPillsVisible(): boolean {
    return this.eFileStatusPills?.some(x => x.isVisible && x.total > 0) ?? false;
  }

  private createQueryParams(): Params {
    let queryParams = Object.assign({}, this.extraQueryParams);

    if (this.eFileStatusPills?.length > 0) {
      queryParams = Object.assign(queryParams, this.createEfileStatusQueryParam());
    }

    return queryParams;
  }

  private createEfileStatusQueryParam(): Params {
    let efileStatusQueryParams = this.eFileStatusPills.flatMap(es => es.eFileStatus.statusses.map(s => s.status));
    return this.isForSubmissionOverview
      ? { submissionStatus: efileStatusQueryParams }
      : { validationStatus: efileStatusQueryParams }
  }
}
